let fadeContents = document.querySelectorAll(".js-fade-in");

const options = {
  root: null,
  rootMargin: "0px 0px", //縦方向 横方向の余白 最初の数字を広げるほど始動が早くなる
  threshold: 0.8, //要素がどれぐらいビューポートに入ったらクラスを付与するか、1で100%
};

const observer = new IntersectionObserver(IntersectFunction, options);

fadeContents.forEach((item) => {
  observer.observe(item);
});

function IntersectFunction(elements) {
  elements.forEach((element) => {
    if (element.isIntersecting) {
      element.target.classList.add("is-show");
    }
  });
}
